import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { formatAmount } from "../../../utility/CommonFunctions";

const AddTdsModal = ({ modal, toggle, modalData, taxableAmount, GetPaymentTicketDetail }) => {
  // console.log("modalData>>>>>>>>",modalData);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      tdsPercentage: '',
      tdsAmount: '',
    }
  });

  const selectedTds = watch("tdsPercentage");

  useEffect(() => {
    if (selectedTds && !isNaN(selectedTds)) {
      const calculatedAmount = (parseFloat(taxableAmount) * parseFloat(selectedTds)) / 100;
      setValue("tdsAmount", calculatedAmount.toFixed(2));
    } else {
      setValue("tdsAmount", '');
    }
  }, [selectedTds, taxableAmount, setValue]);

  useEffect(() => {
    if (modalData) {
      reset({
        tdsPercentage: modalData?.tdsPercentage,
        tdsAmount: modalData?.tdsAmount
      });
    }
  }, [modalData, reset]);

  const closeHandler = () => {
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const submitData = {
      tdsPercentage: data?.tdsPercentage,
      tdsAmount: data?.tdsAmount
    };
    // console.log("submitData>>>>.", submitData);

    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.update_payment_ticket_tds + `?paymentTicketId=${modalData?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          GetPaymentTicketDetail();
          closeHandler();
        } else {
          toast.error(response?.message);
        }
      });
  };

  return (
    <Modal
    className="modal-dialog modal-dialog-scrollable modal-dialog-centered"
    isOpen={modal}
    toggle={closeHandler}
    centered
  >
    <ModalHeader toggle={closeHandler}>
      <h3>{modalData?.tdsAmount > 0 ? "Update" : "Add"} TDS</h3>
    </ModalHeader>

    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalBody className="text-center p-4">
        <div className="modal-content">
          <div className="mb-4">
            <h3 className="text-muted">Taxable Amount : {formatAmount(taxableAmount)}</h3>
          </div>
          <div className="row">
            <div className="col-6">
              <label htmlFor="tds" className="form-label">
                TDS Percentage
              </label>
              <div className="form-group mb-3">
                <select
                  id="tds"
                  className="form-select tds"
                  {...register("tdsPercentage", {
                    required: "This field is Required",
                  })}
                >
                  <option value="">-- Select TDS % --</option>
                  <option value="0">0%</option>
                  <option value="0.1">0.1%</option>
                  <option value="0.5">0.5%</option>
                  <option value="1">1%</option>
                  <option value="2">2%</option>
                  <option value="5">5%</option>
                  <option value="10">10%</option>
                  <option value="20">20%</option>
                  <option value="30">30%</option>
                  <option value="40">40%</option>
                </select>
              </div>
              <ErrorMessage message={errors?.tdsPercentage?.message} />
            </div>

            <div className="col-6">
              <div className="form-group mb-3">
                <label htmlFor="erning" className="form-label">
                  TDS Amount
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  className="form-control"
                  placeholder="Amount"
                  disabled
                  {...register("tdsAmount", {
                    required: "This field is Required",
                  })}
                />
              </div>
              <ErrorMessage message={errors?.tdsAmount?.message} />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={closeHandler}
        >
          Close
        </button>
        <button type="submit" className="btn btn-primary">
          {isLoading ? <Spinner /> : modalData?.tdsAmount > 0 ? "Update" : "Add"}
        </button>
      </ModalFooter>
    </form>
  </Modal>
  );
};

export default AddTdsModal;
